import { createFileRoute } from "@tanstack/react-router";
import { requireRole } from "@/auth/requireRole";
import { ROLE_ADMIN } from "@/constants";
import QualityTestDashboard from "@/views/quality-test/QualityTestDashboard";

export const Route = createFileRoute("/_dashboard/quality-test")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: QualityTest,
});

function QualityTest() {
  return <QualityTestDashboard />;
}
